// extracted by mini-css-extract-plugin
module.exports = {"rangkaianCard":"RangkaianCard_rangkaianCard__2r81L","cardDetail":"RangkaianCard_cardDetail__rDW7n","frame":"RangkaianCard_frame__1HFJy"};